import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const complementOPt = [
    {value: "WITHOUT-COMPLEMENT", label: "Não informado"},
    {value: "INFRACTION", label: "Ato infracional"},
    {value: "INQUIRITY_COMPLAIN", label: "Averiguação"},
    {value: "CONSUMMATE", label: "Consumado"},
    {value: "DENUNCIATION", label: "Denúncia"},
    {value: "TEMPTED", label: "Tentado"}
]

const typeOpt = [
    {value: "WEEKLY_VIEW", label: "Semanal"},
    {value: "MONTHLY_VIEW", label: "Mensal"}
]
const Filters = ({ setFilters, filters, occurrencesDetails }) => {
    const { occurrenceCityFact } = useReportFiltersFetch({fetchOccurrenceCityFact: true});

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <SelectComponent
                        label='Tipo de análise *'
                        wrapValues={true}
                        options={typeOpt}
                        value={filters.analysisType}
                        onChange={(value) => setFilters(prev => ({...prev, analysisType: value}))}
                        instanceId="analysisType"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={occurrencesDetails}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                        instanceId="reason"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Classificação'
                        isMulti={true}
                        wrapValues={true}
                        options={complementOPt}
                        value={filters.complement}
                        onChange={(value) => setFilters(prev => ({...prev, complement: value}))}
                        instanceId="complement"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Município do fato'
                        isMulti={true}
                        wrapValues={true}
                        options={occurrenceCityFact}
                        value={filters.cityFact}
                        onChange={(value) => setFilters(prev => ({...prev, cityFact: value}))}
                        instanceId="cityFact"
                        classNameWrapper={"w-full"}
                    />

                    <div className={"mb-2 ml-1"}>
                        <InputCheckbox
                            id="archivedOccurrences"
                            label="Contabilizar ocorrências arquivadas"
                            checked={filters.archivedOccurrences}
                            onChange={(e) => setFilters(prev => ({...prev, archivedOccurrences: e.target.checked}))}
                        />
                    </div>

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="corporationOnly"
                            label="Apenas ocorrências da minha corporação"
                            checked={filters.corporationOnly}
                            onChange={(e) => setFilters(prev => ({...prev, corporationOnly: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;